import { Card, Skeleton } from "@mui/material";

const StatCardSkeleton = () => (
  <Card
    sx={{
      height: "100%",
      backgroundColor: "#fff",
      borderRadius: 3,
      boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      py: 3,
      px: 2,
    }}
  >
    <Skeleton variant="text" width={150} height={45} sx={{ borderRadius: 2 }} />
    <Skeleton variant="text" width={170} height={35} sx={{ borderRadius: 2, mt: 1 }} />
  </Card>
);

export default StatCardSkeleton;
